import { useState } from 'react'
import { Netzstreifen } from '../../components/Netzstreifen'
import { Link, Navigate, useNavigate } from 'react-router-dom'

import { useCreateTrip, useMe } from '../../hooks/queries'
import { BackIcon } from '../../components/Icons'
import { Restzeichen } from '../../components/Restzeichen'
import { useTextgrenzen } from '../../hooks/useTextgrenzen'

export function NewTripPage() {
  const grenzen = useTextgrenzen()
  const create = useCreateTrip()
  const me = useMe()
  const navigate = useNavigate()
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [von, setVon] = useState('')
  const [bis, setBis] = useState('')

  // Wer nur mitliest, bekommt den Knopf gar nicht zu sehen -- über die Adresse
  // käme er trotzdem hierher, und ein Formular, das beim Absenden abgewiesen
  // wird, ist eine Zumutung. Der Server lehnt es ohnehin ab.
  if (me.data && !me.data.may_create_trips) return <Navigate to="/" replace />

  return (
    <>
      <header className="bar">
        <Link className="icon-button" to="/" aria-label="Zurück">
          <BackIcon />
        </Link>
        <h2 className="bar__title bar__grow">Neue Reise</h2>
      </header>
      <Netzstreifen />

      <div className="scroll-panel">
        <form
          className="card"
          style={{ margin: '0 auto', boxShadow: 'none' }}
          onSubmit={(event) => {
            event.preventDefault()
            create.mutate(
              // Leere Felder gar nicht erst mitschicken -- der Server
              // unterscheidet "nicht gesetzt" von "leer".
              { title, description, starts_on: von || undefined, ends_on: bis || undefined },
              // Direkt in die Einladung: ohne Empfänger ist eine Reise noch
              // kein Beitrag an alle.
              { onSuccess: (trip) => navigate(`/t/${trip.id}/info`) },
            )
          }}
        >
          <p className="card__lead">
            Du bist der Absender. Was du hier schreibst, lesen alle Empfänger –
            ihre Antworten liest nur du.
          </p>

          {create.isError && <p className="notice" role="alert">{create.error.message}</p>}

          <label className="field">
            <span className="field__label">Titel</span>
            <input
              className="field__input"
              required
              maxLength={grenzen.title}
              placeholder="z. B. Norwegen 2026"
              value={title}
              onChange={(event) => setTitle(event.target.value)}
            />
          </label>

          <label className="field">
            <span className="field__label">Beschreibung (kann leer bleiben)</span>
            <textarea
              className="field__input"
              rows={3}
              maxLength={grenzen.trip_description}
              value={description}
              onChange={(event) => setDescription(event.target.value)}
            />
            <Restzeichen wert={description} grenze={grenzen.trip_description} />
          </label>

          {/* Der Zeitraum darf offen bleiben: das Ende steht am Anfang
              selten fest, und eine Reise ohne festen Plan ist der Normalfall. */}
          <div className="row row--wrap">
            <label className="field" style={{ flex: '1 1 150px', marginBottom: 0 }}>
              <span className="field__label">Von (kann leer bleiben)</span>
              <input
                className="field__input"
                type="date"
                value={von}
                max={bis || undefined}
                onChange={(event) => setVon(event.target.value)}
              />
            </label>
            <label className="field" style={{ flex: '1 1 150px', marginBottom: 0 }}>
              <span className="field__label">Bis</span>
              <input
                className="field__input"
                type="date"
                value={bis}
                min={von || undefined}
                onChange={(event) => setBis(event.target.value)}
              />
            </label>
          </div>

          <button className="button" type="submit" style={{ marginTop: 18 }} disabled={create.isPending}>
            {create.isPending ? 'Wird angelegt …' : 'Reise anlegen'}
          </button>
        </form>
      </div>
    </>
  )
}
